import { render, staticRenderFns } from "./ValueChainResult.vue?vue&type=template&id=7dac1788&scoped=true"
import script from "./ValueChainResult.vue?vue&type=script&lang=js"
export * from "./ValueChainResult.vue?vue&type=script&lang=js"
import style0 from "./ValueChainResult.vue?vue&type=style&index=0&id=7dac1788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac1788",
  null
  
)

export default component.exports